import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";
import {
  addCompanySubscriptionData,
  addPromotionalCreditData,
  getCompanyLedgerSummaryData,
  getCompanyLedgerPurchaseHistoryData,
  getCompanySubscriptionsData,
  getTrackServiceBillingData,
  getGoCardlessBillingRequestData,
  getCompanyInvoicesByCompanyIdData,
  updateCompanySubscriptionData,
  getCompnayUserCountData,
  UpdateCompanySubscriptionSiteLicensesData,
  getCompanySubscriptionCostsData
} from "../features/companyServiceBillingSlice/companyServiceBillingSlice";

const reducerName = "companyServiceBilling";
// #region State Setters

// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getTrackServiceBilling = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getTrackServiceBillingData({
        companyId,
      })
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }

  return result;
};

export const addCompanySubscription = async (data) => {
  let result = null;
  try {
    result = await dispatch(addCompanySubscriptionData(data)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};

export const addPromotionalCredit = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPromotionalCreditData(data)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};

export const getCompanySubscriptions = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getCompanySubscriptionsData({
        companyId,
      })
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }
  return result;
};

export const getGoCardlessBillingRequest = async () => {
  let result = [];

  try {
    result = await dispatch(getGoCardlessBillingRequestData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = [];
  }
  return result;
};

export const getCompanyLedgerSummary = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getCompanyLedgerSummaryData({
        companyId,
      })
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }

  return result;
};

export const getCompanyPurchaseHistory = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getCompanyLedgerPurchaseHistoryData({
        companyId,
      })
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }

  return result;
};

export const getCompanyInvoicesByCompanyId = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getCompanyInvoicesByCompanyIdData({
        companyId,
      })
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }
  return result;
};

export const updateCompanySubscription = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateCompanySubscriptionData(data)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};
export const getCompnayUserCount = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getCompnayUserCountData({
        companyId,
      })
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }
  return result;
};
export const updateCompanySubscriptionSiteLicenses = async (data) => {
  let result = null;
  try {
    result = await dispatch(UpdateCompanySubscriptionSiteLicensesData(data)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};
export const getCompanySubscriptionCosts = async (companySubscriptionType) => {
  let result = [];
  try {
    result = await dispatch(getCompanySubscriptionCostsData({
      companySubscriptionType,
    })).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companySubscriptionType);
    result = [];
  } 
  return result;
};